import { postDailyFortuneRateAPI, getDailyFortuneRateAPI } from '@/api/calendarApi';
import { useRnBridge } from '@/composables/useRnBridge';

/**
 * 컨텐츠 평가 composable
 * @param {string} serviceName - API serviceName (ex: 'PERSONALITY_ANALYSIS', 'YEARLY_FORTUNE')
 * @param {Ref<number|null>} guestUserId - 대상 사주 ID ref
 */
export const useContentRate = (serviceName, guestUserId) => {
  const { debuggingHandler } = useRnBridge();

  const ratingResult = ref(0);
  const ratingStatus = ref(false);

  /** 평가 조회 */
  const getRate = async () => {
    try {
      const params = {
        serviceName,
        objectKey: `${guestUserId.value}`,
      };
      const result = await getDailyFortuneRateAPI(params);
      if (result) {
        ratingResult.value = result.score;
        ratingStatus.value = true;
      }
    } catch (e) {
      ratingResult.value = 0;
      ratingStatus.value = false;
      if (e?.response?.status !== 404) {
        debuggingHandler({ action: 'error', message: `컨텐츠 평가 조회 실패: ${e}` });
      }
    }
  };

  /** 평가 등록 */
  const postRate = async (score) => {
    try {
      const params = {
        score,
        serviceName,
        objectKey: `${guestUserId.value}`,
      };
      const result = await postDailyFortuneRateAPI(params);
      if (result) {
        ratingStatus.value = true;
        getRate();
      }
    } catch (e) {
      debuggingHandler({ action: 'error', message: `컨텐츠 평가 등록 실패: ${e}` });
    }
  };

  return { ratingResult, ratingStatus, getRate, postRate };
};
